import { useEffect } from "react";

import { Stack, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { HowdyGoEmbeddedDemo } from "components/HowdyGoEmbeddedDemo";
import {
  ClientAppEvent,
  DATA_PRODUCT_DEMO_HOWDYGO_PUBLICATION_ID,
} from "constants/index";
import { useSubscriptionStatus } from "hooks";
import { PageLayout } from "layouts";

export function AnalyticsUpgradePage() {
  const posthog = usePostHog();
  const { subscription } = useSubscriptionStatus();

  useEffect(() => {
    posthog?.capture(ClientAppEvent.DATA_PAGE_DEMO_VIEWED, {
      subscription_plan: subscription?.subscription_plan ?? undefined,
      howdygo_publication_id: DATA_PRODUCT_DEMO_HOWDYGO_PUBLICATION_ID,
      visited_url: "/shippers/data",
    });
  }, [posthog, subscription]);

  return (
    <PageLayout>
      <Stack textAlign="center" justifyContent="center" alignItems="center">
        <Typography textAlign="center" variant="h6" sx={{ mb: 2 }}>
          The following is demo data. Upgrade your plan to access live analytics
          data.
        </Typography>
      </Stack>
      <HowdyGoEmbeddedDemo
        publicationId={DATA_PRODUCT_DEMO_HOWDYGO_PUBLICATION_ID}
      />
    </PageLayout>
  );
}
